export const ResaleAgreement = {
  get: (
    productName: string,
    firstName?: string,
    lastName?: string,
    address?: string,
    coaDeliveryMessage?: string,
    period?: number,
  ) => {
    const query = {
      ...(firstName && lastName && { name: `${firstName} ${lastName}` }),
      ...(address && { address }),
      ...(productName && { works: productName }),
      ...(coaDeliveryMessage
        ? { coaIncluded: 'false', coaDeliveryMessage }
        : {}),
      ...(period && { period: period.toString() }),
    };
    return `/documents/resale.html?${new URLSearchParams(query).toString()}`;
  },
};
